/* eslint-disable n/no-callback-literal */
import React, { useRef } from 'react';

const useThrottle = (callback, delay) =>
{
	const lastRan = useRef(Date.now());

	const throttledFunction = (...args) =>
	{
		const now = Date.now();

		if (now - lastRan.current >= delay)
		{
			callback(...args);
			lastRan.current = now;
		}
	};

	return throttledFunction;
};

export default useThrottle;